import * as React from 'react'
import { IFlatQuery } from '../../../../common/utils/location/types'
import SearchLinkContainer from '../../../containers/searchLinkContainer'
import { IBlockMatchedComponent } from '../../../pages/category/category'

import * as styles from './searchFiltersBlock.module.css'

interface ISearchFilter {
  title: string
  imgSrc: string
  urlSearchParams: IFlatQuery
}

interface IProps extends IBlockMatchedComponent {
  data: ISearchFilter[]
  title: string
}

const SearchFiltersBlock = ({ title, data }: IProps) => {
  return (
    <section className={styles.root}>
      <div className={styles.searchFiltersWrapper}>
        <h2 className={styles.title}>{title}</h2>
        {data.map((item: ISearchFilter, index: number) => (
          <div className={styles.searchFilter} key={index}>
            <SearchLinkContainer
              className={styles.searchFilterName}
              locationParams={item.urlSearchParams}
            >
              <div
                className={styles.searchFilterHeader}
                style={{ backgroundImage: `url(${item.imgSrc})` }}
              />
              {item.title}
            </SearchLinkContainer>
            <div>
              <SearchLinkContainer
                className={styles.sortFilter}
                locationParams={{
                  ...item.urlSearchParams,
                  sort: 'date'
                }}
              >
                Browse new
              </SearchLinkContainer>
              <SearchLinkContainer
                className={styles.sortFilter}
                locationParams={{
                  ...item.urlSearchParams,
                  sort: 'sales'
                }}
              >
                Browse bestsellers
              </SearchLinkContainer>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default SearchFiltersBlock
